import React from 'react';

import i18n from 'util/i18n';
import { Summary } from 'components/Summary';

import { LEGAL, LEGAL_INVESTIGATIONS_FOREIGN } from 'config/formSections/legal';

import Subsection from 'components/Section/shared/Subsection';
import connectSubsection from 'components/Section/shared/SubsectionConnector';
import { EmptyListInstance } from 'forms/shared/models';
import Branch from 'components/Form/Branch';
import Accordion from 'components/Form/Accordion';
import ForeignInvestigationItem from './ForeignInvestigationItem';


const sectionConfig = {
  key: LEGAL_INVESTIGATIONS_FOREIGN.key,
  section: LEGAL.name,
  store: LEGAL.store,
  subsection: LEGAL_INVESTIGATIONS_FOREIGN.name,
  storeKey: LEGAL_INVESTIGATIONS_FOREIGN.storeKey,
};

export class ForeignInvestigations extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
  }

  update = (queue) => {
    this.props.onUpdate(this.storeKey, {
      List: this.props.List,
      HasForeignInvestigations: this.props.HasForeignInvestigations,
      ...queue,
    });
  };

  updateList = (values) => {
    this.update({
      List: values,
    });
  };

  updateBranch = (values) => {
    this.update({
      HasForeignInvestigations: values,
      List: values.value === 'Yes' ? this.props.List : [],
    });
  };

  Summary = (item, index) => {
    const o = (item && item.Item) || {};
    const foreignGovernment = (o.ForeignGovernment || {}).value || '';

    return Summary({
      type: i18n.t('legal.pvq.investigations.foreign.collection.item'),
      index,
      left: foreignGovernment,
      placeholder: i18n.t('legal.pvq.investigations.foreign.collection.unknown'),
    });
  };

  render() {
    const { errors } = this.props;
    const accordionErrors = errors && errors.filter((e) => e.indexOf('List.accordion') === 0);

    return (
      <div
        className="section-content investigations-pivissues"
        data-section={LEGAL.key}
        data-subsection={LEGAL_INVESTIGATIONS_FOREIGN.key}
      >
        <h1 className="section-header">{i18n.t('legal.pvq.subsection.investigations.foreign')}</h1>

        <Branch
          {...this.props.HasForeignInvestigations}
          name="has_foreigninvestigations"
          label={i18n.t('legal.pvq.investigations.foreign.heading.title')}
          labelSize="h4"
          className="legal-investigations-foreign"
          warning
          onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
          required={this.props.required}
          onUpdate={this.updateBranch}
          scrollIntoView={this.props.scrollIntoView}
          attribute="HasForeignInvestigations"
          showDNK
        />

        {this.props.HasForeignInvestigations.value === 'Yes' &&
          <Accordion
            {...this.props.List}
            defaultState={this.props.defaultState}
            scrollToBottom={this.props.scrollToBottom}
            summary={this.Summary}
            onUpdate={this.updateList}
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
            errors={accordionErrors}
            description={i18n.t('legal.pvq.investigations.foreign.collection.description')}
            appendTitle={i18n.t('legal.pvq.investigations.foreign.collection.appendTitle')}
            appendLabel={i18n.t('legal.pvq.investigations.foreign.collection.appendLabel')}
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
            attribute="List"
          >
            <ForeignInvestigationItem
              name="Item"
              bind
              required={this.props.required}
              scrollIntoView={this.props.scrollIntoView}
              attribute="List"
            />
          </Accordion>
        }
      </div>
    );
  }
}

ForeignInvestigations.defaultProps = {
  name: 'foreign',
  HasForeignInvestigations: {},
  List: EmptyListInstance,
  onUpdate: () => { },
  onError: (value, arr) => arr,
  section: 'legal',
  subsection: 'investigations/foreign',
  dispatch: () => { },
  scrollToBottom: '',
  errors: [],
};

export default connectSubsection(ForeignInvestigations, sectionConfig);
